export default __webpack_public_path__ + "static/media/file-icon.90c5ba04.svg";